<div class="p-card" [style]="{borderTopColor: getStatusColor()}">
  <div class="live-website" pTooltip="Live website">
    <a href="{{account.websiteUrl}}" target="_blank">
      <i class="pi pi-external-link"></i>
    </a>
  </div>


  <div class="header">
    <a href="{{getDestinationUrl()}}">
      <h3 class="p-card-title">{{account.name}}</h3>
      @if (permissions.admin) {
        <li>
          <small class="p-card-subtitle">{{account.accountDescription}}</small>
        </li>
      }
    </a>
  </div>

  <div class="p-card-body icon-container" >
    <ul>
      @if (account.hasNewAds) {
        <li>
          <a href="/web/offer-sets/list/{{account.accountId}}?tab=newActive">
            <i class="pi pi-car"></i>
            New
          </a>
        </li>
      }
      @if (account.hasUsedAds) {
        <li>
          <a href="/web/offer-sets/list/{{account.accountId}}?tab=usedActive">
            <i class="pi pi-car"></i>
            Used
          </a>
        </li>
      }
      @if (account.hasServiceSpecials) {
        <li>
          <a href="/service-specials/{{account.accountId}}">
            <i class="pi pi-wrench"></i>
            Service
          </a>
        </li>
      }
      @if (account.hasPages && permissions.pages) {
        <li>
          <a [routerLink]="['../pages', account.accountId]">
            <i class="pi pi-file"></i>
            Pages
          </a>
        </li>
      }
      @if (account.adwordsActive && permissions.admin) {
        <li>
          <a [routerLink]="['../google-ads-settings', account.accountId]">
            <i class="pi pi-google"></i>
            Ads
          </a>
        </li>
      }
      <li>
        <a href="/settings/globals/view-specials-globals-general/{{account.accountId}}">
          <i class="pi pi-cog"></i>
          Settings
        </a>
      </li>
      @if (account.accountInfo) {
        <li>
          <a href="/settings/account/view-account-info/{{account.accountId}}">
            <i class="pi pi-file-edit"></i>
            Account Info
          </a>
        </li>
      }
      @if (permissions.admin) {
        <li>
          <a href="/settings/account/view-account-inventory/{{account.accountId}}">
            <i class="pi pi-table"></i>
            Inventory
          </a>
        </li>
      }
    </ul>
  </div>

  <small class="account-id">ID: {{account.accountId}}</small>
</div>
